// PRODUCTION: Les imports mock sont conservés mais non utilisés pour les données principales
// Seules les données d'authentification mock sont encore actives pour le fallback
// import { mockAccounts } from '../data/mockAccounts';
// import { mockJournalEntries } from '../data/mockJournals';
// import { mockDeclarations } from '../data/mockDeclarations';
// import { mockLedgerEntries } from '../data/mockLedgerEntries';
// import { mockNotifications } from '../data/mockNotifications';
import type { ApiResponse } from './api/types';

// Mock organization pour le fallback /auth/me
// Structure alignée avec la réponse réelle du backend
const mockOrganization = {
  id: 'org-001',
  name: 'ZERO PANNE',
  registrationNumber: 'CD/GOM/RCCM/22-B-00008',
  taxId: '4876',
  vatNumber: null,
  cnssNumber: null,
  inppNumber: null,
  address: 'Avenue du Commerce',
  city: 'GOMA',
  country: 'RD Congo',
  phone: '+243 972 252 499',
  email: 'info@zeropanne.com',
  website: 'https://zeropanne.com',
  legalForm: 'SARL',
  capital: '10000',
  currency: 'USD',
  accountingMode: 'SYSCOHADA',
  logo: null,
  industry: 'services_informatiques',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString()
};

// Mock user pour le fallback /auth/me
const mockUser = {
  id: 'user-001',
  email: 'admin@zeropanne.com',
  name: 'Jacques Admin',
  firstName: 'Jacques',
  lastName: 'Admin',
  role: 'admin' as const,
  status: 'active' as const,
  emailVerified: true,
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString()
};

// Mock business unit pour le fallback /auth/me
const mockBusinessUnit = {
  id: 'bu-001',
  code: 'ENTRPGEN',
  name: 'Entreprise Générale',
  type: 'company' as const,
  scope: 'company' as const
};

export class FallbackService {
  private static fallbackEnabled = true;
  
  static enableFallback(enabled: boolean = true) {
    this.fallbackEnabled = enabled;
  }

  static async getFallbackData<T>(endpoint: string): Promise<ApiResponse<T> | null> {
    if (!this.fallbackEnabled) {
      return null;
    }

    console.warn(`🔄 Using fallback data for ${endpoint}`);

    try {
      switch (true) {
        // Fallback pour /auth/me - CRITIQUE pour afficher la page Organisation
        case endpoint.includes('/auth/me'):
          return { 
            success: true, 
            data: {
              user: mockUser,
              organization: mockOrganization,
              businessUnit: mockBusinessUnit,
              syncStatus: 'synced'
            } as any 
          };
          
        case endpoint.includes('/accounts'):
          console.warn('⚠️ PRODUCTION: No mock data for accounts - returning empty list');
          return { success: true, data: { data: [], page: 1, pageSize: 20, total: 0, totalPages: 0 } as any };
          
        case endpoint.includes('/journal-entries'):
          console.warn('⚠️ PRODUCTION: No mock data for journal entries - returning empty list');
          return { success: true, data: { data: [], pagination: { page: 1, pageSize: 20, total: 0, totalPages: 0 } } as any };
          
        case endpoint.includes('/declarations'):
          console.warn('⚠️ PRODUCTION: No mock data for declarations - returning empty list');
          return { success: true, data: { data: [], pagination: { page: 1, pageSize: 20, total: 0, totalPages: 0 } } as any };
          
        case endpoint.includes('/ledger/trial-balance'):
          console.warn('⚠️ PRODUCTION: No mock data for ledger - returning empty list');
          return { success: true, data: { items: [], summary: { totalDebit: 0, totalCredit: 0, totalBalance: 0 } } as any };
          
        case endpoint.includes('/fiscal-years'):
          return { 
            success: true, 
            data: [{
              id: '1',
              code: '2024',
              startDate: '2024-01-01',
              endDate: '2024-12-31',
              status: 'open' as const
            }] as any 
          };
          
        case endpoint.includes('/notifications'):
          console.warn('⚠️ PRODUCTION: No mock data for notifications - returning empty list');
          return { 
            success: true, 
            data: { 
              notifications: [], 
              unreadCount: 0,
              pagination: { page: 1, pageSize: 20, total: 0, totalPages: 0 } 
            } as any 
          };
          
        case endpoint.includes('/users'):
          return { 
            success: true, 
            data: [{
              id: '1',
              name: 'Admin User',
              email: 'admin@wanzo.com',
              role: 'admin'
            }] as any 
          };
          
        default:
          return null;
      }
    } catch (error) {
      console.error('Fallback service error:', error);
      return null;
    }
  }
}
